import { CustomAutocomplete } from "common"
import { FormControl, Grid, TextField } from "@mui/material"

export const CashSection = ({ useFetchInit }) => {

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    const { formOpeningMode } = globalStates
    
    const { fetchAllCashRegisters } = FetchData
    const { cashRegisters } = fetchAllCashRegisters


    const { FormLegalizationPayment } = Forms
    const { formState, onInputChange,  onSelectSearchChange } = FormLegalizationPayment


    return (
        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ marginBottom: 2, marginTop: 2 }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
                <FormControl fullWidth>
                    <label htmlFor="idcaja">* Caja</label>
                    <CustomAutocomplete 
                        customId="idcaja"
                        customName="idcaja"
                        customValue={formState.idcaja}
                        customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idcaja', value: value.value }})}
                        customPlaceholder='Seleccionar caja'
                        customOptions={
                            cashRegisters.map(({ idcaja, descripcion_corta }) => ({
                                value: idcaja,
                                name: descripcion_corta
                            }))
                        }
                        customDisableClearable={true}
                        customDisabled={(formState.idmovimiento > 0 || formOpeningMode === 'READONLY') ? true : false}
                    />
                </FormControl>
            </Grid>
            {/* <Grid item xs={12} sm={12} md={12} lg={12}>
                <FormControl fullWidth>
                    <label htmlFor="movimiento_observaciones"> Observaciones</label>
                    <TextField
                        id="movimiento_observaciones"
                        name="movimiento_observaciones"
                        // label="Observaciones"
                        value={formState.movimiento_observaciones}
                        onChange={onInputChange}
                        size='small'
                        multiline
                        rows={3}
                        type="text"
                        variant="outlined"
                        InputProps={{ readOnly: false }}
                    />
                </FormControl>
            </Grid> */}
        </Grid>
    )
}
